let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9TBJu")).then(() => parcelRequire('4PLuQ'));